export function readScoreDraft(gameId) {
  const read = key => {
    try {
      const value = JSON.parse(localStorage.getItem(key) || '{}');
      return value && typeof value === 'object' && !Array.isArray(value) ? value : {};
    } catch { return {}; }
  };
  return {
    scores: read(`localScores_${gameId}`),
    stablefordScores: read(`localStablefordScores_${gameId}`),
  };
}

export function hasScoreDraft(gameId) {
  return Object.values(readScoreDraft(gameId).scores).some(holes => holes && Object.keys(holes).length > 0);
}

export function mergeScoreMaps(base, draft) {
  const merged = { ...base };
  Object.entries(draft).forEach(([player, holes]) => {
    merged[player] = { ...merged[player], ...holes };
  });
  return merged;
}

export function retainPlayers(map, players) {
  const ids = new Set(players.map(player => player.userId));
  return Object.fromEntries(Object.entries(map || {}).filter(([id]) => ids.has(id)));
}

// Only rewrite changed keys, so another tab's in-flight save can still detect new edits.
export function prunePlayerDrafts(gameId, players) {
  for (const prefix of ['localScores', 'localStablefordScores', 'liftedBall']) {
    const key = `${prefix}_${gameId}`;
    const raw = localStorage.getItem(key);
    if (!raw) continue;
    let previous;
    try { previous = JSON.parse(raw); } catch { continue; }
    const next = retainPlayers(previous, players);
    if (Object.keys(next).length === Object.keys(previous || {}).length) continue;
    if (Object.keys(next).length) localStorage.setItem(key, JSON.stringify(next));
    else localStorage.removeItem(key);
  }
}

export function clearPlayerDrafts(gameId) {
  for (const prefix of ['localScores', 'localStablefordScores', 'liftedBall']) {
    localStorage.removeItem(`${prefix}_${gameId}`);
  }
}
